import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import HeroSection from '@/components/LandingPages/HeroSection/HeroSection';
import Skeleton from 'react-loading-skeleton';
export default function HeroSectionWrapper(_a) {
    var _b, _c, _d;
    var isLoading = _a.isLoading, movement = _a.movement;
    var heroImageUrl = movement ? "".concat(process.env.CDN_URL).concat(movement.imageUrl) : '';
    return (_jsx(_Fragment, { children: !movement ? (_jsx(Skeleton, { "aria-busy": "true", containerTestId: "campaign-skeleton", height: 500 })) : (_jsx(HeroSection, { buttons: [
                {
                    label: 'Start a Campaign',
                    styles: (_b = movement.primaryButtonStyles) !== null && _b !== void 0 ? _b : '',
                    testId: 'hero-primary-button',
                    url: (_c = movement.primaryButtonUrl) !== null && _c !== void 0 ? _c : '/onboarding',
                },
            ], description: movement.description, imageProps: { imageAnchor: (_d = movement.imageAnchor) !== null && _d !== void 0 ? _d : '' }, imageUrl: heroImageUrl, isLoading: isLoading, title: movement.title })) }));
}
